import React from 'react';
import {ChevronRightRounded} from '@mui/icons-material'
const MENU_CARD = ({img_src, name}) => {
  return (
  <div className='row_menuCard'>
    <div className='img_box'>
      <img src = {img_src} alt =""/>
    </div>
    <h3>{name}</h3>
    <i className='load_menu'>
      <ChevronRightRounded/>
    </i>
  </div>
  )
};

export default MENU_CARD;
